import { combineLatest, map, Observable } from 'rxjs';
import { components$ } from 'streams/components/components$';
import { currentUserPermissionContext$ } from 'streams/currentUserPermissions/currentUserPermissionContext$';
import { featureContext$ } from 'streams/featureContext$';
import { activeScenario$ } from 'streams/activeScenario/activeScenario$';
import { ImageDropTargetContext } from './imageDropTarget';

export const imageDropTargetContext$: Observable<ImageDropTargetContext> =
  combineLatest([
    components$,
    currentUserPermissionContext$,
    featureContext$,
    activeScenario$,
  ]).pipe(
    map(
      ([
        components,
        permissionContext,
        featureContext,
        activeScenarioState,
      ]) => ({
        componentsById: components.byId,
        permissionContext,
        featureContext,
        activeScenarioState,
      })
    )
  );
